import { createRouter, createWebHistory } from "vue-router";
import AppLayout from "src/layout/AppLayout.vue";
import SearchView from "src/views/SearchView.vue";
import TicketBoardViewVue from "src/views/TicketBoardView.vue";
import ReadyForProcessingView from "src/views/ReadyForProcessingView.vue";
import RecipeManagementView from "src/views/RecipeManagementView.vue";
import ArticleManagementView from "src/views/ArticleManagementView.vue";
import ContractManagementView from "src/views/ContractManagementView.vue";
import { crudRoutes } from "src/router/crud-routes";
import { customCrudRoutes } from "src/router/custom-crud-routes";
import { RouteName } from "src/enums/route-name";

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      component: AppLayout,
      children: [
        {
          path: "/",
          name: "home",
          // component: DashboardView,
          redirect: "/ticket-board",
        },
        {
          path: "/ticket-board",
          name: RouteName.TICKET_BOARD,
          component: TicketBoardViewVue,
        },
        {
          path: "/search",
          name: "search",
          component: SearchView,
        },
        {
          path: "/ready-for-processing",
          name: RouteName.READY_FOR_PROCESSING,
          component: ReadyForProcessingView,
        },
        {
          path: "/recipe-management",
          name: RouteName.RECIPE_MANAGEMENT,
          component: RecipeManagementView,
        },
        {
          path: "/article-management",
          name: RouteName.ARTICLE_MANAGEMENT,
          component: ArticleManagementView,
        },
        {
          path: "/contract-management",
          name: RouteName.CONTRACT_MANAGEMENT,
          component: ContractManagementView,
        },
        ...customCrudRoutes,
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Remove Keycloak-related query parameters, cleaning the url
  if (to.hash.includes('#state=')) {
    const cleanedPath = to.fullPath.split('#')[0];
    next({ path: cleanedPath, replace: true });
  } else {
    next();
  }
});
export default router;
